var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-card',[_c('v-container',[_c('h1',{staticClass:"text-lg-center text-md-center text-sm-center earth-color"},[_vm._v("Volunteer Booking successful.")]),_c('h4',{staticClass:"text-lg-center text-md-center text-sm-center earth"},[_vm._v("Kindly check email for further details.")])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }